import { gettext } from '@eb/i18n';

export const SIGN_IN_METHOD_PASSWORD = 'password';

export const SIGN_IN_METHOD_FACEBOOK_LOGIN = 'facebook_login';
export const SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK = 'facebook';

export const SIGN_IN_METHOD_APPLE_LOGIN = 'apple_login';
export const SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE = 'apple';

export const SIGN_IN_METHOD_GOOGLE_LOGIN = 'google_login';
export const SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE = 'google';

export const LINK_SOCIAL_ACCOUNT_SUCCESS = 'LINK_SOCIAL_ACCOUNT_SUCCESS';
export const UNLINK_SOCIAL_ACCOUNT_SUCCESS = 'UNLINK_SOCIAL_ACCOUNT_SUCCESS';

export const SOCIAL_EXTERNAL_IDENTITY_PROVIDER_MESSAGES = {
    [LINK_SOCIAL_ACCOUNT_SUCCESS]: {
        [SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK]: gettext(
            'Your Facebook account is successfully connected to Eventbrite.',
        ),
    },
    [UNLINK_SOCIAL_ACCOUNT_SUCCESS]: {
        [SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK]: gettext(
            'Your Facebook account is successfully disconnected from Eventbrite.',
        ),
    },
};
